import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";
import { Reservation } from "src/app/models/reservation-model";
import { DefaultService } from "src/app/services/default/default.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";

@Component({
  selector: "app-ma-reservation-details",
  templateUrl: "./ma-reservation-details.component.html",
  styleUrls: ["./ma-reservation-details.component.scss"],
})
export class MaReservationDetailsComponent implements OnInit, AfterViewInit {
  status: any = {
    canceled: { text: "Annulé", class: "badge badge-danger" },
    pending: { text: "En attente", class: "badge badge-warning" },
    "waiting-confirmation": {
      text: "En attente de confirmation",
      class: "badge badge-primary",
    },
    "waiting-modification": {
      text: "En attente de modification",
      class: "badge badge-info",
    },
    confirmed: { text: "Confirmé", class: "badge badge-success" },
    failed: { text: "Échoué", class: "badge badge-danger" },
    refund: { text: "Remboursser", class: "badge badge-danger" },
    complete: { text: "Payé", class: "badge badge-success" },
    partial: { text: "payé partiellement", class: "badge badge-info" },
    none: { text: "---", class: "" },
  };

  subject: string = "";
  message: string = "";

  loading: boolean = true;
  reservation: Reservation;

  constructor(
    private dateFormatterService: DateFormatterService,
    private defaultService: DefaultService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.get_reservation();
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  back() {
    this.location.back();
  }

  date_format(date: any) {
    return this.dateFormatterService.showDateHour(date);
  }

  timestamp_to_date_format(timestamp: any) {
    let value = "";
    if (timestamp != "" && timestamp != null && timestamp != "null") {
      let date = new Date(timestamp * 1000);
      value = this.dateFormatterService.showDateHour(date);
    } else {
      value = "---";
    }
    return value;
  }

  get_reservation() {
    this.activatedRoute.params.subscribe((route) => {
      this.spinner.show();
      this.defaultService
        .get_one("reservations", route.id)
        .subscribe(
          (res: any) => {
            this.reservation = new Reservation(
              Reservation.attributeToJson(res.data)
            );

            setTimeout(() => {
              Webflow.setIFrameHeight();
            }, 500);
          },
          (error) => {
            Webflow.setIFrameHeight();

            if (GenerateErrors.check_if_is_custom_error(error)) {
              Swal.fire({
                title: "Erreur",
                text: GenerateErrors.get_message_error(error),
                icon: "error",
                position: "top",
              });
            } else {
              Swal.fire({
                title: "Erreur",
                text: "Erreur de connexion",
                icon: "error",
                position: "top",
              });
            }
          }
        )
        .add(() => {
          this.spinner.hide();
          this.loading = false;
        });
    });
  }

  annuler() {
    Webflow.setIFrameHeight();
    Swal.fire({
      title: "Annuler la réservation",
      text: "Étes-vous sûre de vouloir annulée la réservation ?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Confirmer`,
      cancelButtonText: `Annuler`,
      position: "top",
      cancelButtonColor: "black",
      confirmButtonColor: "#D63333",
    }).then((result) => {
      if (result.isConfirmed) {
        this.defaultService
          .post("reservations/" + this.reservation.id + "/cancel", {})
          .subscribe(
            (res) => {
              Swal.fire({
                title: "Félicitation",
                text: "La réservation a été annulée avec succès",
                icon: "success",
                position: "top",
              });
              this.get_reservation();
            },
            (error) => {
              if (GenerateErrors.check_if_is_custom_error(error)) {
                Swal.fire({
                  title: "Érreur",
                  text: GenerateErrors.get_message_error(error),
                  icon: "error",
                  position: "top",
                });
              } else {
                Swal.fire({
                  title: "Erreur",
                  text: "Une érreur est survenue",
                  icon: "error",
                  position: "top",
                });
              }
            }
          );
      }
    });
  }

  nuki_action(action: string) {
    this.spinner.show();
    this.defaultService
      .post("reservations/" + this.reservation.id + "/action/" + action, {})
      .subscribe(
        (res) => {
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        },
        (error) => {
          this.spinner.hide();
          Webflow.setIFrameHeight();

          if (GenerateErrors.check_if_is_custom_error(error)) {
            Swal.fire({
              title: "Erreur",
              text: GenerateErrors.get_message_error(error),
              icon: "error",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Erreur de connexion",
              icon: "error",
              position: "top",
            });
          }
        }
      );
  }

  async() {
    this.get_reservation();
  }
}
